module.exports = "/_next/static/images/Sources@2x-9e806505e02ba23494999954ea0a7eef.png";